import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context';
import { AccessLevelConfirmationModal } from './access_level_confirmation_modal';
import { Content } from './content';
import { EmailModal } from './email_modal';
import { Footer } from './footer';
import { Header } from './header';
const containerIsPhoneCss = "c1uots7n";
const containerCss = "cwr7587";
const Container = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const modalBodyCss = "m1wys6iw";
const fixedSectionCss = "f7m3xj3";
const FixedSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fixedSectionCss, props.className)} />;
});
const scrollSectionCss = "s1i31gyn";
const ScrollSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(scrollSectionCss, props.className)} />;
});
const ModalBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalBodyCss, props.className)} />;
});
export const ShareModal = () => {
  const {
    shareModal: {
      isOpen,
      close
    },
    emailModal: {
      open: openEmailModal
    },
    accessLevel: {
      pendingValue,
      isSubmitting,
      confirmPending,
      dismissPending
    },
    recipients: {
      count: recipientCount
    }
  } = useRecapShare();
  return <>
      <Modal isOpen={isOpen} onClose={close}>
        <Container>
          <ModalBody>
            <FixedSection>
              <Header />
            </FixedSection>
            <ScrollSection>
              <Content />
            </ScrollSection>
            <FixedSection>
              <Footer onSendCustomizedEmail={openEmailModal} />
            </FixedSection>
          </ModalBody>
        </Container>
      </Modal>
      <EmailModal />
      <AccessLevelConfirmationModal pendingAccessLevel={pendingValue} isOpen={Boolean(pendingValue)} onClose={dismissPending} onConfirm={confirmPending} isSubmitting={isSubmitting} recipientCount={recipientCount} />
    </>;
};

require("./share_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./share_modal.js");